// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"Video_playerWrapper__25UZm","reactPlayer":"Video_reactPlayer__tUhmC"};